import TopMenu from '../../components/TopMenu/TopMenu.vue'
import Footer from '../../components/Footer/Footer.vue'

export default {
  computed: {
    slogan: function() {
      let line1 = 'We take care of'
      let line2_fixed = 'your '
      let line2_rotate = {
        _1: 'sampling!',
        _2: 'transport!',
        _3: 'industry!'
      }

      switch (this.$store.getters.language.value) {
        case 'nl':
          line1 = 'Wij zorgen voor'
          line2_fixed = 'uw '
          line2_rotate = {
            _1: 'staalname!',
            _2: 'transport!',
            _3: 'industrie!'
          }
          break;
      }

      return {
        line1: line1,
        line2_fixed: line2_fixed,
        line2_rotate: line2_rotate
      }
    },
    motto: function() {
      let motto = 'QSDS helps you with all your sampling and delivery on a 24/7 basis.'

      switch (this.$store.getters.language.value) {
        case 'nl':
          motto = 'QSDS is 24/7 beschikbaar voor al uw staalnames en vervoer.'
          break;
      }

      return motto
    },
    trumps: function() {
      const trumpsArr = []
      let title1 = ''
      let icon1 = 'icon-gauge'
      let text1 = ''

      let title2 = ''
      let icon2 = 'icon-mobile'
      let text2 = ''

      let title3 = ''
      let icon3 = 'icon-location'
      let text3 = ''

      switch (this.$store.getters.language.value) {
        case 'nl':
          title1 = 'Staalname & vervoer'
          text1 = 'Wij voeren staalnames uit in verschillende sectoren en zorgen voor snel transport.'

          title2 = 'Online aanvragen'
          text2 = 'Via ons ultra-modern online klantenportaal kan u 24/7 onze diensten aanvragen.'

          title3 = 'Volgen'
          text3 = 'Te allen tijde kan u uw aanvragen en hun status bekijken. Automatische status updates worden verstuurd doorheen het hele proces.'

          break
        default:
          title1 = 'Sampling & transportation'
          text1 = 'We assist with sampling in all types of industries and provide fast transportation.'

          title2 = 'Request online'
          text2 = 'Using our state-of-the-art online client portal, you can request our services 24/7.'

          title3 = 'Tracking'
          text3 = 'At all times you can consult your requests and their status online. Automatic status updates are sent during the whole process.'

          break
      }

      trumpsArr.push({
        title: title1,
        icon: icon1,
        text: text1
      })
      trumpsArr.push({
        title: title2,
        icon: icon2,
        text: text2
      })
      trumpsArr.push({
        title: title3,
        icon: icon3,
        text: text3
      })

      return trumpsArr
    },
    segment2: function() {
      let title1 = ''
      let title2 = ''
      let title3 = ''
      let description = {
        _1: '',
        _2: '',
        _3: ''
      }
      let buttonTxt = ''

      switch (this.$store.getters.language.value) {
        case 'nl':
          title1 = 'We streven naar het faciliteren van de business van onze klant'
          title2 = 'door hen te helpen om de meest kostenefficiënte,'
          title3 = 'betrouwbare en tijdsbesparende service te bieden.'
          description = {
            _1: 'Door te kiezen voor QSDS, kiest u ervoor om te werken met een hedendaags platform,',
            _2: 'hoogopgeleide professionals en',
            _3: 'bespaart u zichzelf frustraties, tijd en geld.'
          }
          buttonTxt = 'Contacteer ons'
          break
        default:
          title1 = 'We strive to facilitate our client\'s business'
          title2 = 'by helping them deliver the most cost-effective,'
          title3 = 'reliable and timesaving service.'
          description = {
            _1: 'By choosing QSDS, you choose to work with a contemporary platform,',
            _2: 'highly qualified professionals and',
            _3: 'you will save yourself frustrations, time and money.'
          }
          buttonTxt = 'Contact us'
          break
      }

      return {
        title1: title1,
        title2: title2,
        title3: title3,
        description: description,
        buttonTxt: buttonTxt
      }
    }
  },
  components: {
    'TopMenu': TopMenu,
    'Footer': Footer
  },
  methods: {
    goToContactFromHome: function () {
      let url = '/en/contact'

      switch (this.$store.getters.language.value) {
        case 'nl':
          url = '/nl/contact'
          break
      }

      window.location.href = url;
    }
  },
  beforeMount() {
    const path = this.$route.path.split('/')
    let language = {
      text: '',
      value: ''
    }

    if (path.length > 0) {
      switch (path[1]) {
        case 'nl':
        case 'en':
          language.value = path[1]
          break
        default:
          /*for (let idx in navigator.languages) {
            const navLanguage = navigator.languages[idx]

            switch (navLanguage) {
              case 'nl':
              case 'en':
                language.value = navLanguage
                break
            }

            if (language.value !== '') {
              break
            }
          }*/

          // if (language.value === '') {
            language.value = 'en'
          // }
      }
    }

    switch (language.value) {
      case 'nl':
        language.text = 'Nederlands'
        break
      case 'en':
        language.text = 'English'
        break
    }

    this.$store.commit("language", language)
  },
  mounted() {
    $("#languageBar").dropdown();

    let $slider = $(".slider");
    const count = $slider.find('.item').length;
    const itemHeight = $slider.prev().outerHeight();
    $slider.css("height", itemHeight);

    let timeout = 1000;
    let currentItem = 1;
    let offset = 0;
    slider($slider, offset, timeout, count, currentItem, itemHeight);
  }
}

function slider($slider, offset, timeout, count, currentItem, itemHeight) {
  offset = (offset - itemHeight) % (currentItem * itemHeight);

  setTimeout(function () {
    if (currentItem === 1) {
      timeout = 1000;
    }

    $slider.find("> *").css({
      "transform": "translateY(" + offset + "px)",
    });

    currentItem++;

    if (count + 1 === currentItem) {
      currentItem = 1;
      timeout = count * 1000;
    }

    slider($slider, offset, timeout, count, currentItem, itemHeight);
  }, timeout);
}



// WEBPACK FOOTER //
// ./src/pages/page/home/home.js